import { OTCRow } from './types';

// Helper function to get consistent row ID (matches DataGrid's getRowId logic)
export const getRowId = (row: OTCRow): string => {
  return (row._id || row.id) as string;
};

// Helper function to convert selectedRows array to proper DataGrid selection model format
export const createGridSelectionModel = (selectedRows: string[]) => {
  return {
    type: 'include' as const,
    ids: new Set(selectedRows),
  };
};

// Helper function to format last sync date with timezone
export const formatLastSyncDate = (
  lastSyncDate: string | null | undefined
): string | undefined => {
  if (!lastSyncDate) return undefined;

  const date = new Date(lastSyncDate);
  if (isNaN(date.getTime())) return undefined;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;

  const offsetMinutes = -date.getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
  const offsetMins = Math.abs(offsetMinutes) % 60;
  const offsetSign = offsetMinutes >= 0 ? '+' : '-';
  const offsetStr = `UTC${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMins).padStart(2, '0')}`;

  return `Last sync: ${formattedDate} (${offsetStr})`;
};
